import {NavStyle} from 'shared/constants/AppEnums';
import UiWiseAppLayout from './UiWiseAppLayout';

const Layouts = {
  [NavStyle.UIWISE]: UiWiseAppLayout,
};
export default Layouts;
